import qa from 'query-string';
import {isIOS, isAndroid, isWX, isQQ} from './ua';
import {UNIVERSAL_LINKS, UNIVERSAL_SCHEMA, DOWNLOAD} from '../../constants';

function openUpApp(type = '', params = {}) {
  const nativeURL = `${type}?${qa.stringify(params)}`;
  const android_schema = `${UNIVERSAL_SCHEMA}${nativeURL}`;
  if (isIOS()) {
    window.location.href = `https://${UNIVERSAL_LINKS}/${nativeURL}`;
  }

  else if (isAndroid() && (isWX() || isQQ())) {
    window.location.href = `${DOWNLOAD.yyb}&${qa.stringify({android_schema})}`;
  }

  else {
    window.location.href = android_schema;
    setTimeout(() => {
      window.location.href = DOWNLOAD.yyb;
    }, 2000);
  }
}

export {openUpApp};


// WEBPACK FOOTER //
// ./src/tools/lib/openApp.js